<div class="container-fluid">
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-10 mt-3">
            <ng-container *ngIf="this.providerreg.other_data.tabViewData.selected_tab == 0">
                <div class="row toplogin">
                    <div class="form-back h4 my-4">
                        <a class="egd-theme" role="button" [routerLink]="['/', this.slug]"
                        >&#8592; Back</a>
                    </div>
                    <div>
                        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL', '', '_self')">
                            <img [src]="this.logo_url" class="egd-navbar-logo" alt="egd-logo" style="float: right" />
                        </a>
                    </div>
                </div>
                <div class="form-heading-section mt-4">
                    <h2>Register</h2>
                    <p class="form-sub-heading">
                        Just a step away from your practice more efficient.
                    </p>
                    <p class="form-tagline"><small>Register</small></p>
                </div>

                <form #registerForm="ngForm" (ngSubmit)="providerRegistrationSubmit()" accept-charset="UTF-8"
                    id="register_form">
                    <div class="form-div">
                        <div class="form-group row pl-md-1 justify-content-center">
                            <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="name">Name*</label>
                            <div class="col-sm-12 col-md-5">
                                <input type="text" class="form-control rounded-pill" id="firstname" name="firstname"
                                    aria-describedby="name" placeholder="First Name*"
                                    [(ngModel)]="this.providerreg.other_data.first_name" #first_name="ngModel"
                                    [pKeyFilter]="name_input" [class.form-input-error]="
                              first_name.invalid &&
                              (first_name.dirty || first_name.touched) &&
                              first_name.errors.required
                            " [class.form-input-success]="
                              !first_name.invalid &&
                              (first_name.dirty || first_name.touched) &&
                              !first_name.errors?.required
                            " required />
                                <div *ngIf="
                              first_name.invalid && (first_name.dirty || first_name.touched)
                            " class="col-sm-12">
                                    <div *ngIf="first_name.errors.required" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        First name is required.
                                    </div>
                                    <div *ngIf="first_name.errors.FieldValidator"
                                        class="col-sm-12 alert alert-danger m-2" role="alert">
                                        Invalid First name.
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-5">
                                <input type="text" class="form-control rounded-pill" id="middlename" name="middlename"
                                    aria-describedby="middlename" placeholder="Middle Name"
                                    [(ngModel)]="this.providerreg.other_data.middle_name" [pKeyFilter]="name_input" />
                            </div>
                        </div>
                        <div class="form-group row justify-content-center">
                            <div class="col-md-10 col-sm-12">
                                <input type="text" class="form-control rounded-pill" id="lastname" name="lastname"
                                    aria-describedby="lastname" placeholder="Last Name*"
                                    [(ngModel)]="this.providerreg.other_data.last_name" #last_name="ngModel"
                                    [pKeyFilter]="name_input" [class.form-input-error]="
                              last_name.invalid &&
                              (last_name.dirty || last_name.touched) &&
                              last_name.errors.required
                            " [class.form-input-success]="
                              !last_name.invalid &&
                              (last_name.dirty || last_name.touched) &&
                              !last_name.errors?.required
                            " required />
                                <div *ngIf="
                              last_name.invalid && (last_name.dirty || last_name.touched)
                            " class="col-sm-12 px-0">
                                    <div *ngIf="last_name.errors.required" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Last name is required.
                                    </div>
                                    <div *ngIf="last_name.errors.FieldValidator"
                                        class="col-sm-12 alert alert-danger m-2" role="alert">
                                        Invalid Last name.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row justify-content-center">
                            <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="orgname">Organization/Legal
                                Entity Name*</label>
                            <div class="col-md-10 col-sm-12">
                                <input type="text" class="form-control rounded-pill" id="orgname" name="orgname"
                                    aria-describedby="orgname" placeholder="Organization/Legal Entity Name"
                                    [(ngModel)]="this.providerreg.api_data.provider.name" #org_name="ngModel"
                                    [pKeyFilter]="name_input" [class.form-input-error]="
                              org_name.invalid &&
                              (org_name.dirty || org_name.touched) &&
                              org_name.errors.required
                            " [class.form-input-success]="
                              !org_name.invalid &&
                              (org_name.dirty || org_name.touched) &&
                              !org_name.errors?.required
                            " required />
                                <div *ngIf="
                              org_name.invalid && (org_name.dirty || org_name.touched)
                            " class="col-sm-12 px-0">
                                    <div *ngIf="org_name.errors.required" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Organization name is required.
                                    </div>
                                    <div *ngIf="org_name.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Invalid Organization name.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row justify-content-center">
                            <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="shortorgname">Organization/Legal
                                Entity Short Name*</label>
                            <div class="col-md-10 col-sm-12">
                                <input type="text" class="form-control rounded-pill" id="shortorgname" name="shortorgname"
                                    aria-describedby="shortorgname" placeholder="Organization/Legal Entity Short Name"
                                    [(ngModel)]="this.providerreg.api_data.provider.shortName" #org_short_name="ngModel"
                                    [pKeyFilter]="name_input" [class.form-input-error]="
                              org_short_name.invalid &&
                              (org_short_name.dirty || org_short_name.touched) &&
                              org_short_name.errors.required
                            " [class.form-input-success]="
                              !org_short_name.invalid &&
                              (org_short_name.dirty || org_short_name.touched) &&
                              !org_short_name.errors?.required
                            " required />
                                <div *ngIf="
                              org_short_name.invalid && (org_short_name.dirty || org_short_name.touched)
                            " class="col-sm-12 px-0">
                                    <div *ngIf="org_short_name.errors.required" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Organization Short name is required.
                                    </div>
                                    <div *ngIf="org_short_name.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Invalid Organization Short name.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row justify-content-center">
                            <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="bi_number">Business
                                Identification Number*</label>
                            <div class="col-md-10 col-sm-12">
                                <input type="text" class="form-control rounded-pill" id="bi_number" name="bi_number"
                                    aria-describedby="bi_number" placeholder="Identification Number"
                                    [(ngModel)]="this.providerreg.api_data.provider.identification_number"
                                    #identification_number="ngModel" [pKeyFilter]="buesinessIdentification"
                                    [class.form-input-error]="
                              identification_number.invalid &&
                              (identification_number.dirty || identification_number.touched) &&
                              identification_number.errors.required
                            " [class.form-input-success]="
                              !identification_number.invalid &&
                              (identification_number.dirty || identification_number.touched) &&
                              !identification_number.errors?.required
                            " required />
                                <div *ngIf="
                              identification_number.invalid && (identification_number.dirty || identification_number.touched)
                            " class="col-sm-12 px-0">
                                    <div *ngIf="identification_number.errors.required"
                                        class="col-sm-12 alert alert-danger m-2" role="alert">
                                        Business Identification Number is required.
                                    </div>
                                    <div *ngIf="identification_number.errors.FieldValidator"
                                        class="col-sm-12 alert alert-danger m-2" role="alert">
                                        Invalid Business Identification Number.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row justify-content-center">
                            <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="email">Email*</label>
                            <div class="col-md-10 col-sm-12">
                                <input id="email" name="email" type="email" class="form-control rounded-pill"
                                    aria-describedby="email" FieldValidator="email" placeholder="Enter your email"
                                    [(ngModel)]="this.providerreg.api_data.provider.email" #email="ngModel"
                                    [class.form-input-error]="(email.invalid && (email.dirty || email.touched)) && (email.errors?.FieldValidator )"
                                    [class.form-input-success]="(!email.invalid && (email.dirty || email.touched)) && !(email.errors?.FieldValidator )"
                                    required>
                                <div *ngIf="(email.invalid && (email.dirty || email.touched))" class="col-sm-12">
                                    <div *ngIf="email.errors.required" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Email is required.
                                    </div>
                                    <div *ngIf="email.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Invalid Email.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row justify-content-center">
                            <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="password">Create
                                Password*</label>
                            <div class="col-md-10 col-sm-12">
                                <div class="input-group">
                                    <input id="password" name="password" [type]="
                                this.providerreg.other_data.password_input.isPassword
                                  ? 'password'
                                  : 'text'
                              " class="form-control input-of-input-icon" aria-describedby="password"
                                        placeholder="********" [(ngModel)]="this.providerreg.api_data.provider.password"
                                        #password="ngModel" minlength="8" FieldValidator="password"
                                        [class.form-input-error]="
                                password.invalid &&
                                (password.dirty || password.touched) &&
                                password.errors.required
                              " [class.form-input-success]="
                                !password.invalid &&
                                (password.dirty || password.touched) &&
                                !(password.errors?.required || password.errors?.minlength)
                              " required />
                                    <div class="input-group-append">
                                        <span class="input-group-text icon-of-input-icon" [class.form-input-error]="
                                  password.invalid &&
                                  (password.dirty || password.touched) &&
                                  password.errors.required
                                " [class.form-input-success]="
                                  !password.invalid &&
                                  (password.dirty || password.touched) &&
                                  !(password.errors?.required || password.errors?.minlength)
                                ">
                                            <i toggle="#password-field" role="button" class="text-dark fa fa-fw"
                                                [ngClass]="{
                                    'fa-eye':
                                      this.providerreg.other_data.password_input.isPassword,
                                    'fa-eye-slash':
                                      !this.providerreg.other_data.password_input.isPassword
                                  }" (click)="
                                    this.providerreg.other_data.password_input.toggleType()
                                  "></i>
                                        </span>
                                    </div>
                                </div>
                                <div *ngIf="password.invalid && (password.dirty || password.touched)" class="col-sm-12">
                                    <div *ngIf="password.errors.required" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Password is required.
                                    </div>
                                    <div *ngIf="password.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Password should contain minimum 8 characters, at least 1
                                        Uppercase, 1 Special Character and 1 number.
                                    </div>
                                    <div *ngIf="password.errors.minlength" class="col-sm-12 alert alert-danger m-2"
                                        role="alert">
                                        Minimum length should be of 8 characters.
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div *ngIf="
                                this.providerreg.other_data.password_input.tipsPasswordShowed
                              " class="col-sm-12 alert alert-danger m-2" role="alert">
                                        Password should contain minimum 8 characters, at least 1
                                        Uppercase, 1 Special Character and 1 number.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row justify-content-center">
                            <div class="col-sm-12 col-md-5">
                                <div class="row">
                                    <label class="col-sm-12 font-weight-bold ml-md-3 pl-md-2"
                                        for="country">Country*</label>
                                    <div class="col-sm-12 ml-md-2">
                                        <select name="country" class="custom-select custom-select mb-3"
                                            [(ngModel)]="this.providerreg.other_data.selected_country"
                                            (change)="onChangeCountry()" #country="ngModel" [class.form-input-error]="
                                  country.invalid &&
                                  (country.dirty || country.touched) &&
                                  country.errors.required
                                " [class.form-input-success]="
                                  !country.invalid &&
                                  (country.dirty || country.touched) &&
                                  !country.errors?.required
                                " required>
                                            <option value="" disabled selected>
                                                Choose your country*
                                            </option>
                                            <option *ngFor="let country of this.providerreg.other_data.countries"
                                                value="{{ country.value }}">
                                                {{ country.label }}
                                            </option>
                                        </select>
                                    </div>
                                    <div *ngIf="country.invalid && (country.dirty || country.touched)"
                                        class="col-sm-12">
                                        <div *ngIf="country.errors.required" class="col-sm-12 alert alert-danger m-2"
                                            role="alert">
                                            Country is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-5">
                                <div class="row">
                                    <label class="col-sm-12 font-weight-bold" for="primary_no">Primary Mobile
                                        Number*</label>
                                    <div class="col-sm-12 ml-md-2">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span
                                                    class="input-group-text prepend-of-append-prepend patient_reg_input_border"
                                                    [class.form-input-error]="
                                      primary_no?.invalid &&
                                      (primary_no?.dirty || primary_no?.touched) &&
                                      (primary_no.errors?.required ||
                                        primary_no.errors?.maxlength ||
                                        primary_no.errors?.pattern)
                                    " [class.form-input-success]="
                                      !primary_no?.invalid &&
                                      (primary_no?.dirty || primary_no?.touched) &&
                                      !(
                                        primary_no.errors?.required ||
                                        primary_no.errors?.maxlength ||
                                        primary_no.errors?.pattern
                                      )
                                    ">
                                                    {{
                                                    this.providerreg.other_data.selected_country_data
                                                    .phone_code
                                                    }}
                                                </span>
                                            </div>
                                            <input id="primary_no" name="primary_no" type="text"
                                                class="form-control input-of-append-prepend"
                                                aria-describedby="primary_no" placeholder="Primary Contact No.*"
                                                [(ngModel)]="this.providerreg.other_data.primary_contact_no"
                                                [pattern]="phoneNumber" maxlength="20" #primary_no="ngModel"
                                                [class.form-input-error]="
                                    primary_no?.invalid &&
                                    (primary_no?.dirty || primary_no?.touched) &&
                                    (primary_no.errors?.required ||
                                      primary_no.errors?.maxlength ||
                                      primary_no.errors?.pattern)
                                  " [class.form-input-success]="
                                    !primary_no?.invalid &&
                                    (primary_no?.dirty || primary_no?.touched) &&
                                    !(
                                      primary_no.errors?.required ||
                                      primary_no.errors?.maxlength ||
                                      primary_no.errors?.pattern
                                    )
                                  " required />
                                        </div>
                                    </div>

                                    <div *ngIf="
                                primary_no?.invalid &&
                                (primary_no?.dirty || primary_no?.touched)
                              " class="col-sm-12 pl-2">
                                        <div *ngIf="primary_no.errors?.required"
                                            class="col-sm-12 alert alert-danger m-2" role="alert">
                                            Primary Phone No. is required.
                                        </div>
                                        <!-- <div *ngIf="primary_no.errors?.maxlength" class="col-sm-12 alert alert-danger m-2"
                                                  role="alert">
                                                  Phone number should be of 10 digits.
                                              </div> -->
                                        <div *ngIf="primary_no.errors?.pattern" class="col-sm-12 alert alert-danger m-2"
                                            role="alert">
                                            Only Numbers are allowed.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row ml-md-5">
                            <div class="form-group form-check ml-3">
                                <label class="form-check-label">
                                    By providing your phone number, you agree to receive text messages
                                    from eGlobalDoctors. Message and data rates may apply. Message
                                    frequency varies.
                                </label>
                            </div>
                        </div>

                        <div class="form-group row justify-content-center">
                            <div class="m-3">
                                <div id="recaptcha-div2">
                                    <re-captcha *ngIf="this.providerreg.other_data.recaptchaData.recaptcha_Reset"
                                        class="recaptcha ng-valid" name="recaptcha" matInput
                                        style="display: inline-block" (resolved)="resolved($event)"
                                        [(ngModel)]="this.providerreg.api_data.provider.recaptcha" #recaptcha="ngModel"
                                        [siteKey]="sitekey" required>
                                    </re-captcha>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row justify-content-center">
                            <div class="col-md-10 col-sm-12">
                                <div class="form-submit-button my-3">
                                    <button type="submit" [disabled]="
                                isPosting() ||
                                !registerForm.valid
                              " class="btn btn-primary font-weight-bold text-white p-2">
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="this.providerreg.other_data.tabViewData.selected_tab == 1">
                <div class="form-heading-section mt-4">
                    <h2>Verify Mobile</h2>
                    <p class="form-sub-heading">We have sent an OTP on</p>
                    <h2>{{ this.providerreg.api_data.provider.phone_number }}</h2>
                </div>
                <div class="form-div">
                    <form #otpForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8" id="register_form">
                        <div class="form-group row">
                            <otp-input class="col-12" [isPrimeNg]="false"
                                [otp_data]="this.providerreg.api_data.otp_data" (otp_resend)="otp_resend()">
                            </otp-input>
                        </div>

                        <div class="form-group row">
                            <div class="col-md-9 col-sm-12">
                                <div class="form-submit-button my-3">
                                    <button type="submit" class="btn btn-primary font-weight-bold text-white p-2"
                                        [disabled]="isPosting() || !otpForm.valid">
                                        Verify
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </ng-container>
            <div class="row">
                <div class="mt-3 mx-2">
                    <div class="row">
                        <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                        </app-loading>
                    </div>
                    <app-error-messages [api_result]="this.providerreg.api_data.create_api_result"></app-error-messages>
                    <app-error-messages [api_result]="this.providerreg.api_data.otp_data.otp_api_result">
                    </app-error-messages>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mx-4 mx-md-0 mx-lg-0">
                    <p>
                        Already have an account?
                        <a [routerLink]="['/', this.slug, 'user', 'login', 'patient']"
                        > Sign in</a>
                    </p>
                </div>
            </div>

            <div class="footer-copyright-section mt-4">
                <p class="text-center">
                    2025 Copyright <span>&#169;</span> All rights reserved by
                    <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL', '', '_self')"
                        style="color: #1850a0">eGlobalDoctors</a>
                </p>
            </div>
        </div>
    </div>
</div>